import { mergeDeepLeft } from 'ramda';

export const deepMerge = mergeDeepLeft;
